import { getNonUmbracoUrl, getUmbracoMediaUrl, getUmbracoPDFUrl } from "."

type LinkType = "Content" | "Media" | "External" | string

export type BasicMultiUrlPickerItem = {
    type: LinkType
    url?: string | null
}

export function getLinkHrefFromMultiUrlPickerItem(link?: BasicMultiUrlPickerItem | null) {
    const url = link?.url || ""
    if (!url) {
        return "/"
    }

    const type = link?.type

    if (type === "Media") {
        if (url.toLowerCase().endsWith(".pdf")) {
            return getUmbracoPDFUrl(url)
        }
        return getUmbracoMediaUrl(url)
    }

    if (url.toLowerCase().endsWith(".pdf")) {
        return getUmbracoPDFUrl(url)
    }

    return getNonUmbracoUrl(url)
}
